"use strict";

exports.__esModule = true;
exports.required = void 0;

var _util = require("../util");

var required = (0, _util.wrapSyncFunc)(function (rule, value) {
  var required = rule.required;

  if (!required) {
    return;
  }

  return Boolean(Array.isArray(value) && value.length) || !Array.isArray(value) && value != null && value !== '';
});
exports.required = required;